import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { Season } from "../models/leagueInterfaces";
import { getCurrentSeason } from "../services/seasonsService";
import { toast } from "react-toastify";
import { storeVersion, migrate, onRehydrateStorage } from "./versioning";

const defaultValues = {
  version: storeVersion,
  currentSeason: null,
  isBusy: false,
};

interface SeasonStore {
  version: number;
  currentSeason: Season | null;
  isBusy: boolean;
  getCurrentSeason: () => Promise<void>;
}

export const useSeasonsStore = create<SeasonStore>()(
  devtools(
    persist(
      (set) => ({
        ...defaultValues,
        getCurrentSeason: async () => {
          try {
            set({ isBusy: true });
            const response = await getCurrentSeason();
            if (response.code && response.code === 6017) {
              set({ currentSeason: response.result, isBusy: false });
              return;
            } else if (response.code && response.code === 6012) {
              set({ currentSeason: null, isBusy: false });
            } else {
              set({ currentSeason: null, isBusy: false });
              console.error("Error fetching season:", response);
              toast.error(response.message);
            }
          } catch (error) {
            set({ isBusy: false });
            console.error("Error fetching season:", error);
            toast.error("Error fetching season details. Will load from cache if available.");
          }
        },
        
      }),
      {
        name: "seasonStore",
        storage: createJSONStorage(() => localStorage),
        onRehydrateStorage: onRehydrateStorage(defaultValues),
        migrate: migrate(defaultValues),
      }
    ),
    { name: "seasonStore", enabled: process.env.NODE_ENV === "development" }
  )
);
